import type { CollectInputAnswer, CollectInputField } from "@common/schemas/icertis"

export interface EditorSidesConfirmation {
  editorsTotal: number
  editorsMoved: number
  editorsUnplaced: number
}

export function editorSidesConfirmation(fields: CollectInputField[], answer: CollectInputAnswer): EditorSidesConfirmation | null {
  const field = fields.find((candidate) => candidate.type === "editor_sides")
  if (field?.type !== "editor_sides") return null
  const value = answer.values[field.id]
  if (value?.type !== "editor_sides") return null
  const offeredSideByName = new Map(field.editors.map((editor) => [editor.name, editor.side]))
  return {
    editorsTotal: value.editors.length,
    editorsMoved: value.editors.filter((editor) => offeredSideByName.get(editor.name) !== editor.side).length,
    editorsUnplaced: value.editors.filter((editor) => editor.side === "unplaced").length,
  }
}
